import { type ReactElement } from 'react';
import './PageWrapperSidebar.css';

interface Props {
  children: ReactElement[] | ReactElement;
  isShortSideBar: boolean;
  setIsShortSideBar: (value: (prev: boolean) => boolean) => void;
  // setIsAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>
  setIsVendorAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsBannerAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsProductAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsFeedbackAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
}

export const PageWrapperSidebar: React.FC<Props> = ({
  children,
  setIsShortSideBar,
  isShortSideBar,
  setIsVendorAccordionOpen,
  setIsBannerAccordionOpen,
  setIsProductAccordionOpen,
  setIsFeedbackAccordionOpen,
  className
}) => {
  const clickHandler = (): void => {
    setIsShortSideBar((prev: boolean) => !prev);
    setIsVendorAccordionOpen(false);
    setIsBannerAccordionOpen(false);
    setIsProductAccordionOpen(false);
    setIsFeedbackAccordionOpen(false);
  };

  const classSidebar = !isShortSideBar
    ? 'sidebar-custom bg-body-tertiary shadow '
    : 'sidebar-custom--short bg-body-tertiary shadow';

  return (
    <div
      className={`sidebar border-right col-3 col-lg-2 p-0 bg-body-tertiary ${className}`}
    >
      <div className={classSidebar}>
        <div className="offcanvas-body d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto">
          <button className="toggle-sidebar" onClick={clickHandler}>
            {isShortSideBar ? (
              <img
                className="toggle-svg"
                src="/assets/icons/sidebar-expand-toggle.svg"
              />
            ) : (
              <img
                className="toggle-svg"
                src="/assets/icons/sidebar-collapse-toggle.svg"
              />
            )}
          </button>
          {children}
        </div>
      </div>
    </div>
  );
};
